export const ANALYTICS_ACTION = {
  view: 'view',
  click: 'click',
} as const;

export const ANALYTICS_ITEM_TYPE = {
  ITEM_TYPE: 'button',
  BANNER: 'banner',
  POPUP: 'popup',
  LINK: 'link',
  ICON: 'icon',
  TOGGLE: 'toggle',
  ELEMENT: 'element',
  TAB: 'tab',
  FIELD: 'field',
  MESSAGE: 'message',
  SELECTOR_ITEM: 'selector_item',
  BUTTON: 'button',
  FILTER: 'filter',
  WIDGET: 'widget',
  RADIOBUTTON: 'radiobutton',
};
